import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Select, Alert, Table, message } from "antd";
import companyService from "../../../services/company.service";

const { Option } = Select;

const TableItems = ({ rows }: { rows: any[] }) => {
  // Sumar los precios
  const totalPrice = rows.reduce((sum, row) => sum + Number(row.price), 0);

  const columns: any = [
    {
      title: "#",
      dataIndex: "certificate_number",
      key: "certificate_number",
      sorter: false,
    },
    {
      title: "Precio",
      dataIndex: "price",
      key: "price",
      sorter: false,
      align: "right",
    },
  ];

  return (
    <Table
      pagination={false}
      style={{ marginTop: 10 }}
      size="small"
      columns={columns}
      dataSource={rows}
      footer={() => (
        <div style={{ textAlign: "right" }}>
          <strong>Total: </strong>PEN {Number(totalPrice).toFixed(2)}
        </div>
      )}
    />
  );
};
export interface BillingModalProps {
  rows: any[];
  open: boolean;
  onOk: (data: any) => void;
  onCancel: () => void;
  confirmLoading?: boolean;
  descriptionDefault?: string;
}

const BillMultiple: React.FC<BillingModalProps> = ({
  open,
  onOk,
  onCancel,
  confirmLoading,
  descriptionDefault = "",
  rows,
}) => {
  const [form] = Form.useForm();

  const fetchCompany = async () => {
    const { data } = await companyService.find(rows[0]?.company_id);
    form.setFieldsValue({
      customer_name: data.fullname,
      document_number: data.document_number,
      document_type: data.document_type,
    });
  };

  const [type, setType] = useState<string>("summary");

  useEffect(() => {
    if (rows.length == 0) {
      return;
    }
    fetchCompany();
  }, [rows]);

  // const onSend = () => {
  //   onOk(form.getFieldsValue());
  // };

  const onSend = async () => {
    try {
      const values = await form.validateFields();
      onOk(values);
    } catch (error) {}
  };

  return (
    <Modal
      title="Generar varias facturas"
      open={open}
      onOk={onSend}
      onCancel={onCancel}
      okText="Confirmar"
      cancelText="Cancelar"
      confirmLoading={confirmLoading}
    >
      <Form
        form={form}
        layout="horizontal"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        initialValues={{ description: descriptionDefault }}
      >
        <Form.Item
          name="payment_method"
          label="Método de pago"
          initialValue={"cash"}
          rules={[{ required: true, message: "Ingresa el método de pago" }]}
        >
          <Select>
            <Option value="cash">Efectivo</Option>
            <Option value="yape">Yape</Option>
            <Option value="bank-transfer">Transferencia Bancaria</Option>
            <Option value="credit-card">Izipay</Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="voucher"
          label="N° Operación"
          rules={[{ required: false, message: "Ingresa Numero de Operación" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="phone"
          label="N° Celular"
          rules={[{ required: true, message: "Ingresa Numero Celular" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="notes"
          label="Notas"
          rules={[{ required: false, message: "Notas" }]}
        >
          <Input.TextArea />
        </Form.Item>

        <TableItems rows={rows} />
      </Form>
    </Modal>
  );
};

export default BillMultiple;
